import Typography from 'typography';

const typography = new Typography({
  baseFontSize: '18px',
  baseLineHeight: 2,
  scaleRatio: 1,
  headerFontFamily: ['BorisBlackBloxx', 'sans-serif'],
  headerGrey: '30',
  headerWeight: '400',
  bodyFontFamily: ['Roboto', 'sans-serif'],
  bodyGray: '30',
  bodyWeight: '400',
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js